import { useEffect, useState } from 'react';
import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { addCorrection, correctionListSelector, setCorrectionsLoading } from 'rahtab-redux/slices/correctionListSlice';
import { setLoadCorrection } from 'rahtab-redux/slices/loadsSlice';

export const useLoadRevisionList = (assignFinalCode: string) => {
  const [idList, setIdList] = useState<Set<string> | undefined>();
  const dispatch = useAppDispatch();
  const { loads } = useSelector((state) => state.loads);
  const corrections = useSelector(correctionListSelector(Array.from(idList?.values() || []), assignFinalCode));
  const { loading: correctionLoading } = useSelector((state) => state.correctionList);
  const [refetch, { called, loading }] = useFetchCallType<GetCorrectionRemainingHistoryProps>(
    'GetCorrectionRemainingHistory',
    {
      params: `AssignFinallCode=${assignFinalCode}`,
      onCompleted: (d) => {
        const temp = new Set(idList);
        dispatch(
          setLoadCorrection({
            ...d,
            id: assignFinalCode,
          }),
        );
        d.CorrectionList.forEach((d, index) => {
          temp.add(index.toString());
          dispatch(
            addCorrection({
              ...d,
              id: `${assignFinalCode}-${index}`,
            }),
          );
        });
        setIdList(temp);
      },
    },
  );
  useEffect(() => {
    if (correctionLoading === 'refreshing') {
      refetch();
      dispatch(setCorrectionsLoading('idle'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correctionLoading]);
  return {
    data: {
      correctionInfo: {
        conflictionAmount: loads[assignFinalCode].conflictionAmount,
        conflictionPercent: loads[assignFinalCode].conflictionPercent,
        defectiveAmount: loads[assignFinalCode].defectiveAmount,
        defectivePrecent: loads[assignFinalCode].defectivePrecent,
        unitText: loads[assignFinalCode].unitText,
        otherReasonAmount: loads[assignFinalCode].otherReasonAmount,
        otherReasonPercent: loads[assignFinalCode].otherReasonPercent,
        outSaleAmount: loads[assignFinalCode].outSaleAmount,
        outSalePercent: loads[assignFinalCode].outSalePercent,
        correctionsCount: loads[assignFinalCode].correctionsCount,
      },
      correctionList: corrections,
    },
    loading,
    called,
    refetch,
  };
};

export interface GetCorrectionRemainingHistoryProps {
  CorrectionCount: string; // تعداد اصلاح موجودی
  ContradictionAmount: string; //مقدار مغایرت
  DefectiveAmount: string; //مقدار معیوب شده
  OutNetSaleAmount: string; //مقدار فروش خارج ازشبکه
  OtherReasonAmount: string; //مقدار دلایل دیگر
  MeasureName: string; //واحد
  ContradictionPercent: string; //درصد مغایرت
  DefectivePercent: string; //درصد معیوب شده
  OutNetSalePercent: string; //درصد فروش خارج ازشبکه
  OtherReasonPercent: string; //درصد دلایل دیگر
  CorrectionList: RevisionList[]; //لیست اصلاح موجودی های یک تخصیص
}
export interface RevisionList {
  ReasonName: string;
  Amount: string;
  Measurename: string;
  CorrectionDate: string;
}
